import firebase from "../firebase";

export default function({ officeId, licenseId }) {
  return firebase.functions().httpsCallable("allFunctions")({
    funcRole: "officeUser",
    funcName: "selectLicense",
    data: { officeId, licenseId }
  });
}
